var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-twitter",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "twitter-2",
    transform: "translate(0.000000, 2.000000)",
    fill: "#03A9F4",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24,2.3085 C23.1075,2.7 22.1565,2.9595 21.165,3.0855 C22.185,2.4765 22.9635,1.5195 23.3295,0.366 C22.3785,0.933 21.3285,1.3335 20.2095,1.557 C19.3065,0.5955 18.0195,0 16.6155,0 C13.8915,0 11.6985,2.211 11.6985,4.9215 C11.6985,5.3115 11.7315,5.6865 11.8125,6.0435 C7.722,5.844 4.1025,3.8835 1.671,0.897 C1.2465,1.6335 0.9975,2.4765 0.9975,3.384 C0.9975,5.088 1.875,6.5985 3.183,7.473 C2.3925,7.458 1.617,7.2285 0.96,6.867 C0.96,6.882 0.96,6.9015 0.96,6.921 C0.96,9.312 2.6655,11.298 4.902,11.7555 C4.5015,11.865 4.065,11.9175 3.612,11.9175 C3.297,11.9175 2.979,11.8995 2.6805,11.8335 C3.318,13.782 5.127,15.2145 7.278,15.261 C5.604,16.5705 3.4785,17.3595 1.1775,17.3595 C0.774,17.3595 0.387,17.3415 -2.66453526e-15,17.292 C2.1795,18.6975 4.7625,19.5 7.548,19.5 C16.602,19.5 21.552,12 21.552,5.499 C21.552,5.2815 21.5445,5.0715 21.534,4.863 C22.5105,4.17 23.331,3.3045 24,2.3085 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.ea47b4692a2e5b50ae1aa19581c1ea7a.svg";
export { ForwardRef as ReactComponent };